import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/views/Layout'

// 本项目目前使用固定路由即可；权限模块仍会读取 asyncRoutes，保持导出避免告警/运行时报错
export const asyncRoutes = []

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'dashboard' }
    }]
  },

  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Article',
        component: () => import('@/views/article/index'),
        meta: { title: '文章管理', icon: 'el-icon-document' }
      },
      {
        path: 'create',
        name: 'ArticleCreate',
        component: () => import('@/views/article/edit'),
        hidden: true,
        meta: { title: '新增文章', activeMenu: '/article' }
      },
      {
        path: 'edit/:id',
        name: 'ArticleEdit',
        component: () => import('@/views/article/edit'),
        hidden: true,
        meta: { title: '编辑文章', activeMenu: '/article' }
      }
    ]
  },

  {
    path: '/category',
    component: Layout,
    children: [{
      path: '',
      name: 'Category',
      component: () => import('@/views/category/List'),
      meta: { title: '栏目管理', icon: 'el-icon-menu' }
    }]
  },

  {
    path: '/banner',
    component: Layout,
    children: [{
      path: '',
      name: 'Banner',
      component: () => import('@/views/banner/List'),
      meta: { title: '轮播图管理', icon: 'el-icon-picture' }
    }]
  },

  {
    path: '/user',
    component: Layout,
    children: [{
      path: '',
      name: 'User',
      component: () => import('@/views/user/List'),
      meta: { title: '用户管理', icon: 'el-icon-user' }
    }]
  },

  // 兼容旧路径（历史页面/书签）
  {
    path: '/content/article',
    redirect: '/article',
    hidden: true
  },
  {
    path: '/content/article/create',
    redirect: '/article/create',
    hidden: true
  },
  {
    path: '/content/article/edit/:id',
    redirect: to => `/article/edit/${to.params.id}`,
    hidden: true
  },
  {
    path: '/content/category',
    redirect: '/category',
    hidden: true
  },
  {
    path: '/banner/index',
    redirect: '/banner',
    hidden: true
  },
  {
    path: '/system/user',
    redirect: '/user',
    hidden: true
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
